import { render, staticRenderFns } from "./TemplatePopup.vue?vue&type=template&id=1aa7f490&scoped=true"
import script from "./TemplatePopup.vue?vue&type=script&lang=js"
export * from "./TemplatePopup.vue?vue&type=script&lang=js"
import style0 from "./TemplatePopup.vue?vue&type=style&index=0&id=1aa7f490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa7f490",
  null
  
)

export default component.exports